import { Component, Input } from "@angular/core";
import { Router } from "@angular/router";
import { IArticleDto } from "src/app/core/models/article.model";
import { WorkorderLineFromArticleService } from "src/app/workorders/shared/workorder-line-from-article.service";
import { ActionSheetService } from "../action-sheet/action-sheet.service";

@Component({
	selector: "af-barcode-scanner-action-sheet",
	templateUrl: "./barcode-scanner-action-sheet.component.html"
})
export class BarcodeScannerActionSheetComponent {
	@Input() action: string;
	@Input() scannedBarcode: string;
	@Input() article: IArticleDto;
	@Input() articleDescription: string;
	@Input() orderId: string;
	@Input() state: any;

	constructor(
		private actionSheetService: ActionSheetService,
		private router: Router,
		private workorderLineFromArticleService: WorkorderLineFromArticleService
	) {}

	createArticleToWorkOrderLines() {
		this.addArticleAndToWorkorderLine(`workorders/${this.orderId}/edit/orderlines/add`);
		this.dismiss("closeBarcodeScanner"); // dismiss actionsheet and close barcode scanner because type has been given
	}

	createArticleToWorkOrderLinesAndContinue() {
		const openBarcodeOnEntry = true;
		this.addArticleAndToWorkorderLine(`workorders/${this.orderId}/edit/orderlines`, openBarcodeOnEntry);
		this.dismiss("closeBarcodeScanner"); // dismiss actionsheet and close barcode scanner because type has been given
	}

	addArticleToWorkOrderLines() {
		this.addWorkorderLine(this.article.article_id, this.orderId); // article is always found in this case
		this.dismiss("closeBarcodeScanner"); // dismiss actionsheet and close barcode scanner because type has been given
	}

	addArticleToWorkOrderLinesAndContinue() {
		this.workorderLineFromArticleService.postArticleToWorkorderLine(this.article, this.orderId); // post found article to workorderline
		// dismiss actionsheet and start a new scan: the native scanner is one-shot, so the scan
		// session is already gone by the time this action sheet is shown and has to be reopened
		// explicitly. A plain dismiss (Annuleren / backdrop) must NOT rescan. See TEN-22397.
		this.dismiss("continueBarcodeScanner");
	}

	async addWorkorderLine(articleId?: string, orderID?: string) {
		if (this.article && orderID) {
			this.router.navigate([`workorders/${this.orderId}/edit/orderlines/add/${articleId}`], {
				state: {
					routeBackPoint: `workorders/${this.orderId}/edit/orderlines`
				}
			});
		}
	}

	async addArticleAndToWorkorderLine(routeBackPoint: string, openBarcodeOnEntry?: boolean) {
		await this.router.navigate(["/articles/add"], {
			state: {
				scannedBarcode: this.scannedBarcode,
				orderId: this.orderId,
				openBarcodeOnEntry: openBarcodeOnEntry ? openBarcodeOnEntry : null,
				routeBackPoint
			}
		});
	}

	dismiss(dismissType?: string) {
		this.actionSheetService.dismissAll(dismissType);
	}
}
